export default {
  state: {
    // 主入口标签页
    mainTabs: [],
    // 当前标签页名
    mainTabsActiveName: '',
    warnTimer:null,// 警报定时器
  },
  mutations: {
    updateMainTabs (state, tabs) {
      state.mainTabs = tabs
    },
    updateMainTabsActiveName (state, name) {
      state.mainTabsActiveName = name
    },
    updateTimer(state, timer){
        state.warnTimer = timer
    }
  },
  // actions: {
  //   cleardata(state){
  //     state.mainTabs = [];
  //   }
  // }

  
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js